const NAME = "CONCEPTS_SET_SETTINGS_PAGE";

export default NAME;
